import { ChatConfig } from "../../model/chat/chat-config";
import { ChatToken } from "../../model/chat/chat-token";
import { otsBaseApi } from "../ots-api";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: []});

export const chatApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatConfig: builder.query<ChatConfig, void>({
      query: () => ({
        url: `/chat/config`,
        method: "GET",
      }),
    }),
    getChatToken: builder.query<ChatToken, void>({
      query: () => ({
        url: "/chat/token",
        method: "POST",
      }),
    }),
  })
});

export const {
  useGetChatConfigQuery,
  useGetChatTokenQuery,
} = chatApi;
